import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiV1 } from "../Auth/Interceptor";

const initialStateValue = {
    modalDisplay: false,
    notifications: {
        notifications: [],
        loading: 'idle',
        error: null,
    }
}

const fetchNotifications = createAsyncThunk('notifications/fetchNotifications', async () => {
    try {
        const response = await apiV1.get(`notification/getAll`);
        return response.data.data;
    } catch(error) {
        throw error;
    }
});

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: initialStateValue,
    reducers: {
        toggleModal: (state, _) => {
            state.modalDisplay = !state.modalDisplay;
        },
        closeModal: (state, _) => {
            state.modalDisplay = false;
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchNotifications.pending, (state) => {
            state.notifications.loading = 'loading';
        })
        .addCase(fetchNotifications.fulfilled, (state, action) => {
            state.loading = 'succeeded';
            state.notifications.notifications = action.payload;
        })
        .addCase(fetchNotifications.rejected, (state, action) => {
            state.loading = 'failed';
            state.notifications.error = action.error.message;
        });
    },
});

export const {
    toggleModal,
    closeModal,
} = notificationsSlice.actions;

export {
    fetchNotifications,
}

export default notificationsSlice.reducer;
